import "./RestrictedRouteComponent.scss";
import HeadingComponent from "@/components/common-components/heading/HeadingComponent";
import {Button} from "@/components/ui/button.tsx";
import {DEFAULT_ROUTE} from "@/constants/RoutesConfig";
import {motion} from "framer-motion";
import {useNavigate} from "react-router-dom";
import {useCallback, useEffect, useState} from 'react';
import ChipComponent from "@/components/ui/ChipComponent.tsx";
import FloatingIconsRendererComponent
    from "@/components/common-components/floating-icons-renderer/FloatingIconsRendererComponent.tsx";
import FooterComponent from "@/components/common-components/footer/FooterComponent.tsx";


const RestrictedRouteComponent = () => {
    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(8);
    const [isNavigating, setIsNavigating] = useState(false);

    const handleNavigation = useCallback(async () => {
        if (isNavigating) return; // Prevent multiple navigations
        setIsNavigating(true);
        // Start the exit animation
        setTimeout(() => {
            navigate(DEFAULT_ROUTE);
        }, 400); // Match the duration of the exit animation
    },[navigate,isNavigating]);


    useEffect(() => {
        // Set up countdown timer
        if (countdown > 0 && !isNavigating) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);

            return () => clearTimeout(timer);
        } else if (countdown === 0) {
            handleNavigation();
        }
    }, [countdown, isNavigating, handleNavigation]);

    return (
        <>
            <div
                className="min-h-[calc(100vh-100px)] w-full overflow-hidden flex flex-direction-column items-center justify-center">
                <motion.main
                    initial={{opacity: 0, scale: 0.95, filter: "blur(0px)"}}
                    whileInView={{opacity: 1, scale: 1}}
                    transition={{duration: 0.3, ease: "easeInOut"}}
                    className="flex flex-col items-center justify-center w-full py-8"
                >
                    <ChipComponent text={'403 Forbidden'}/>
                    <HeadingComponent>
                        <span className="text-primary">Access Denied!</span> You don't <br/> have permission to view this page
                    </HeadingComponent>
                    <div className="text-secondary-foreground mb-8 mt-[-18px] text-[18px] text-center">
                        This content requires proper authorization.<span className={'text-secondary'}> Please<br/> sign in or contact your administrator.</span>
                    </div>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4 }}
                        className="flex gap-4 justify-center flex-wrap"
                    >
                        <Button
                            onClick={handleNavigation}
                            disabled={isNavigating}
                            variant="outline"
                            className="relative"
                        >
                            <span>Go Home in </span>
                            <span className="font-semiBold ml-1">{countdown}s</span>
                        </Button>
                    </motion.div>
                </motion.main>
                <FloatingIconsRendererComponent/>
            </div>
            <FooterComponent/>
        </>
    );
};

export default RestrictedRouteComponent;
